import { render, staticRenderFns } from "./NewsAdd.vue?vue&type=template&id=c6d9d9d0&scoped=true&"
import script from "./NewsAdd.vue?vue&type=script&lang=js&"
export * from "./NewsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6d9d9d0",
  null
  
)

export default component.exports